import { FC } from 'react';

import { borderRadius, borderWidth } from '@coachhubio/nova-borders';
import { getBackgroundColor, getBorderColor } from '@coachhubio/nova-colors';
import { CenteredColumn, CenteredRow } from '@coachhubio/nova-flex';
import { Layout } from '@coachhubio/nova-layout';
import styled from 'styled-components';

import { DashboardSectionsNoInsights } from './DashboardSectionsNoInsights';

import Footer from '~/components/Footer';

const headerHeight = 56;

const LayoutContainer = styled.div`
  min-height: calc(100vh - ${headerHeight}px);
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledLayout = styled(Layout)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledCenteredColumn = styled(CenteredColumn)`
  max-width: 1200px;
  width: 100%;
  height: 480px;
  margin: 0 auto;
  justify-content: center;

  ${getBackgroundColor('neutral')}

  ${getBorderColor('neutral80')};
  ${borderWidth('s')}
  ${borderRadius('m')}
`;

export const DashboardSectionsNoInsightsLayout: FC = () => {
  return (
    <LayoutContainer>
      <StyledLayout>
        <StyledCenteredColumn>
          <CenteredRow gap="5xl" justifyContent="space-around">
            <DashboardSectionsNoInsights />
          </CenteredRow>
        </StyledCenteredColumn>
      </StyledLayout>
      <Footer />
    </LayoutContainer>
  );
};
